export default __webpack_public_path__ + "static/media/irrigation-1.a4f88aba.jpg";